import SortableItem from '../SortableItem/SortableItem';
import { Grid, GridItem } from '../../../Grid/Grid';
import { Thumbnail } from '../../../Thumbnail/Thumbnail';
import { Media } from '../Media/Media';
import type { PreviewProps } from './Preview.typed';
import { Add } from '../Add/Add';
import { Sortable } from '../Sortable/Sortable';
import * as Styled from './Preview.styled';

const Preview = (props: PreviewProps) => {
  const {
    media,
    setMedia,
    removeMedia,
    onClickAdd,
    maxUploads,
    renderThumbnail,
    onSort,
    addButtonRef,
  } = props;

  const showAdd = media.length < maxUploads;

  return (
    <Sortable
      data={media}
      setData={setMedia}
      onSort={onSort}
      dropSlot={(activeId) => (
        <Media
          // TODO: fix this non-null assertion issue. Ideally we handle the case where the media
          // item is not found in the array.
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          media={media.find((item) => item.id === activeId)!}
          onClickDiscard={() => undefined}
        />
      )}
    >
      {(activeId) => (
        <Grid
          columns={10}
          columnSpacing={{ lg: 'S8' }}
          rowSpacing={{ lg: 'S8' }}
        >
          {media.map((upload, index) => (
            <GridItem sm={3.33334} md={2} lg={2} key={upload.id}>
              <Styled.Item>
                <Styled.EmptySlot>
                  <Thumbnail image="" />
                </Styled.EmptySlot>
                <SortableItem id={upload.id}>
                  <div
                    style={{
                      opacity: activeId === upload.id ? 0 : 1,
                    }}
                  >
                    <Media media={upload} onClickDiscard={removeMedia}>
                      {renderThumbnail({ media: upload, index })}
                    </Media>
                  </div>
                </SortableItem>
              </Styled.Item>
            </GridItem>
          ))}
          {showAdd && (
            <GridItem sm={3.33334} md={2} lg={2}>
              <Add
                ref={addButtonRef}
                onClick={onClickAdd}
                count={media.length}
                max={maxUploads}
              />
            </GridItem>
          )}
        </Grid>
      )}
    </Sortable>
  );
};

export { Preview };
